import { Component, ElementRef, Input, OnInit, Renderer2, OnDestroy } from '@angular/core';
import { LocalUtils } from '../../restricted/restricted.utils';
import { Router } from '@angular/router';
import { HeaderService } from '../app-header/app.header.service';
import * as tinycolor from 'tinycolor2';

@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="nav">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`
})
export class AppSidebarNavComponent implements OnDestroy {

  user: any = {};
  sideColor

  constructor(private router: Router) {
    
    this.user = JSON.parse(LocalUtils.decrypt(localStorage.getItem('user')));

    HeaderService.sidebarColor.subscribe(sideColor => {
      this.sideColor = sideColor;
    });

  }

  ngOnDestroy() {
    HeaderService.sidebarColor.unsubscribe();
  }

  // public navOrganization = navOrganization;
  // public nav = nav;

  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  public exit(){
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    location.reload();
  }
  
}

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'" [ngStyle]="{'background-color': itemColor ? itemColor : '#444f51'}">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [ngStyle]="{'background-color': dropdownColor ? dropdownColor : ''}"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent implements OnDestroy {

  @Input() item: any;
  itemColor
  dropdownColor
  itemColorAux
  sideColor
  hoverColor

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor( private router: Router )  {

    HeaderService.sidebarItemColor.subscribe(itemColor => {
      this.itemColor = itemColor;
      this.itemColorAux = itemColor;
    });
    HeaderService.sidebarHoverColor.subscribe(hoverColor => {
      this.hoverColor = hoverColor;
    });
    HeaderService.sidebarColor.subscribe(sideColor => {
      this.sideColor = sideColor;
      this.dropdownColor = sideColor;
    });
  }

  ngOnDestroy() {
    HeaderService.sidebarItemColor.unsubscribe();
    HeaderService.sidebarHoverColor.unsubscribe();
    HeaderService.sidebarColor.unsubscribe();
  }

}

@Component({
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="!isExternalLink()"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]"
      [ngStyle]="{'color': textColor}">
      <i *ngIf="isIcon()" class="{{ link.icon }}" [ngStyle]="{'color': textColor}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    
    <a *ngIf="isExternalLink()" [ngStyle]="{'color': textColor}" [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'" target="_blank" href="{{link.url}}" [ngStyle]="{'color': textColor}">
      <i *ngIf="isIcon()" class="{{ link.icon }}" [ngStyle]="{'color': textColor}"></i> {{ link.name }} <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>`
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;
  colors = LocalUtils.colorsDefault;
  textColor = '#ffffff';

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isExternalLink() {
    return this.link.url.substring(0, 4) === 'http' || this.link.url.substring(0, 4) === 'https' || this.link.url.substring(0, 4) === 'help' ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() {
    HeaderService.textSidebarColor.subscribe(r => {
      this.textColor = r;
    });
  }
}

@Component({
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" [ngStyle]="{'color': textColor}" appNavDropdownToggle href="#">
      <i *ngIf="isIcon()" class="{{ link.icon }}" [ngStyle]="{'color': textColor}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;
  colors = LocalUtils.colorsDefault;
  textColor = '#ffffff';

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor() {
    HeaderService.textSidebarColor.subscribe(r => {
      this.textColor = r;
    });
  }
}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if ( this.title.class ) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if ( this.title.wrapper && this.title.wrapper.element ) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// ./src/app/components/app-sidebar-nav/app-sidebar-nav.component.ts